// GENERATED by scripts/harvest-demo-catalog.ts — do not edit by hand.
// Edit scripts/demo-category-map.ts, then re-run the harvest.

import img_105_quadcopter_altitude_hold from "@/assets/shots/catalog/105-quadcopter-altitude-hold.png";
import img_106_quadcopter_attitude_stabilization from "@/assets/shots/catalog/106-quadcopter-attitude-stabilization.png";
import img_33_inverted_pendulum from "@/assets/shots/catalog/33-inverted-pendulum.png";
import img_47_dc_motor_electromech from "@/assets/shots/catalog/47-dc-motor-electromech.png";
import img_61_robotic_arm_motion from "@/assets/shots/catalog/61-robotic-arm-motion.png";
import img_64_abs_slip_control from "@/assets/shots/catalog/64-abs-slip-control.png";
import img_113_reactor_scram_transient from "@/assets/shots/catalog/113-reactor-scram-transient.png";
import img_114_reactor_xenon_poisoning from "@/assets/shots/catalog/114-reactor-xenon-poisoning.png";
import img_117_activated_sludge_load_step from "@/assets/shots/catalog/117-activated-sludge-load-step.png";
import img_120_aeration_do_pid_control from "@/assets/shots/catalog/120-aeration-do-pid-control.png";
import img_92_ph_neutralization from "@/assets/shots/catalog/92-ph-neutralization.png";
import img_65_cascade_reactor from "@/assets/shots/catalog/65-cascade-reactor.png";
import img_145_theis_aquifer_pumping_test from "@/assets/shots/catalog/145-theis-aquifer-pumping-test.png";
import img_147_contaminant_plume_100_year_migration from "@/assets/shots/catalog/147-contaminant-plume-100-year-migration.png";
import img_169_greenland_mass_balance_warming from "@/assets/shots/catalog/169-greenland-mass-balance-warming.png";
import img_80_ice_albedo_feedback from "@/assets/shots/catalog/80-ice-albedo-feedback.png";
import img_155_co2_atmospheric_growth_50yr from "@/assets/shots/catalog/155-co2-atmospheric-growth-50yr.png";
import img_62_climate_radiative from "@/assets/shots/catalog/62-climate-radiative.png";
import img_128_paris_fatigue_pressure_vessel from "@/assets/shots/catalog/128-paris-fatigue-pressure-vessel.png";
import img_125_pearlite_jmak_isothermal from "@/assets/shots/catalog/125-pearlite-jmak-isothermal.png";
import img_173_sdof_building_resonance from "@/assets/shots/catalog/173-sdof-building-resonance.png";
import img_126_arrhenius_diffusion_temperature_sweep from "@/assets/shots/catalog/126-arrhenius-diffusion-temperature-sweep.png";
import img_88_mass_spring_resonance from "@/assets/shots/catalog/88-mass-spring-resonance.png";
import img_28_mass_spring_damper from "@/assets/shots/catalog/28-mass-spring-damper.png";
import img_72_qpsk_constellation from "@/assets/shots/catalog/72-qpsk-constellation.png";
import img_63_telecom_pll from "@/assets/shots/catalog/63-telecom-pll.png";
import img_90_lms_equalizer from "@/assets/shots/catalog/90-lms-equalizer.png";
import img_84_agc_pll_chain from "@/assets/shots/catalog/84-agc-pll-chain.png";
import img_83_hampel_outlier from "@/assets/shots/catalog/83-hampel-outlier.png";
import img_86_allan_variance from "@/assets/shots/catalog/86-allan-variance.png";
import img_34_buck_converter from "@/assets/shots/catalog/34-buck-converter.png";
import img_104_grid_tie_pq_inverter from "@/assets/shots/catalog/104-grid-tie-pq-inverter.png";
import img_190_pem_electrolyzer_hydrogen_production from "@/assets/shots/catalog/190-pem-electrolyzer-hydrogen-production.png";
import img_189_lithium_ion_charge_discharge_cycle from "@/assets/shots/catalog/189-lithium-ion-charge-discharge-cycle.png";
import img_82_freq_droop_governor from "@/assets/shots/catalog/82-freq-droop-governor.png";
import img_94_power_factor_correction from "@/assets/shots/catalog/94-power-factor-correction.png";
import img_137_sir_epidemic_curve from "@/assets/shots/catalog/137-sir-epidemic-curve.png";
import img_138_seir_incubation_delay from "@/assets/shots/catalog/138-seir-incubation-delay.png";
import img_68_glucose_insulin from "@/assets/shots/catalog/68-glucose-insulin.png";
import img_141_windkessel_arterial_pressure from "@/assets/shots/catalog/141-windkessel-arterial-pressure.png";
import img_129_iv_bolus_plasma_decay from "@/assets/shots/catalog/129-iv-bolus-plasma-decay.png";
import img_32_ecg_rpeak_detection from "@/assets/shots/catalog/32-ecg-rpeak-detection.png";
import img_57_kepler_hohmann from "@/assets/shots/catalog/57-kepler-hohmann.png";
import img_66_marine_nomoto from "@/assets/shots/catalog/66-marine-nomoto.png";
import img_87_salinity_mixing from "@/assets/shots/catalog/87-salinity-mixing.png";
import img_185_mach_zehnder_fringe_pattern from "@/assets/shots/catalog/185-mach-zehnder-fringe-pattern.png";
import img_186_malus_law_polarizer_sweep from "@/assets/shots/catalog/186-malus-law-polarizer-sweep.png";
import img_97_laser_rate_equations from "@/assets/shots/catalog/97-laser-rate-equations.png";
import img_181_mm1_queue_utilization_hockey_stick from "@/assets/shots/catalog/181-mm1-queue-utilization-hockey-stick.png";
import img_101_black_scholes_delta from "@/assets/shots/catalog/101-black-scholes-delta.png";
import img_76_bollinger_bands from "@/assets/shots/catalog/76-bollinger-bands.png";
import img_100_holt_demand_forecast from "@/assets/shots/catalog/100-holt-demand-forecast.png";
import img_182_eoq_inventory_sqrt_demand_sweep from "@/assets/shots/catalog/182-eoq-inventory-sqrt-demand-sweep.png";
import img_184_bullwhip_variance_amplification_quadratic from "@/assets/shots/catalog/184-bullwhip-variance-amplification-quadratic.png";

export interface CatalogEntry {
  slug: string;
  title: string;
  description: string;
  image: string;
  imageAlt: string;
}
export interface CatalogCategory {
  intro: string;
  highlights: CatalogEntry[];
  rest: string[];
}

export const DEMO_CATALOG: Record<string, CatalogCategory> = {
  "control-systems-robotics": {
    intro: "Closed-loop control and robotics — autopilots, motor drives, and manipulators modelled and tuned on the canvas.",
    highlights: [
      {
        slug: "105-quadcopter-altitude-hold",
        title: "Quadcopter altitude hold",
        description: "An altitude-hold outer-loop P controller cascaded into a first-order vertical-speed plant and altitude integrator — a quadcopter holding height.",
        image: img_105_quadcopter_altitude_hold,
        imageAlt: "Screenshot from the “Quadcopter altitude hold” DjiniousLab demo",
      },
      {
        slug: "106-quadcopter-attitude-stabilization",
        title: "Quadcopter attitude stabilization",
        description: "Cascaded outer attitude PID and inner pitch-rate loop holding a quadcopter level against a wind disturbance.",
        image: img_106_quadcopter_attitude_stabilization,
        imageAlt: "Screenshot from the “Quadcopter attitude stabilization” DjiniousLab demo",
      },
      {
        slug: "33-inverted-pendulum",
        title: "Inverted pendulum",
        description: "The classic unstable-equilibrium problem — a closed-loop PID balancing an inverted pendulum upright.",
        image: img_33_inverted_pendulum,
        imageAlt: "Screenshot from the “Inverted pendulum” DjiniousLab demo",
      },
      {
        slug: "47-dc-motor-electromech",
        title: "DC motor electromechanics",
        description: "A multi-domain DC motor: the electrical pin domain coupled to 1-D rotational mechanics, solved as one acausal model.",
        image: img_47_dc_motor_electromech,
        imageAlt: "Screenshot from the “DC motor electromechanics” DjiniousLab demo",
      },
      {
        slug: "61-robotic-arm-motion",
        title: "Robotic-arm joint motion",
        description: "A trapezoidal velocity profile with joint-limit clamping — the motion-planning primitive of a robotic arm.",
        image: img_61_robotic_arm_motion,
        imageAlt: "Screenshot from the “Robotic-arm joint motion” DjiniousLab demo",
      },
      {
        slug: "64-abs-slip-control",
        title: "ABS slip control",
        description: "An anti-lock controller modulating brake pressure to hold wheel slip in the traction band during hard braking.",
        image: img_64_abs_slip_control,
        imageAlt: "Screenshot from the “ABS slip control” DjiniousLab demo",
      },
    ],
    rest: ["Drone IMU sensor fusion","Quadcopter waypoint mission","Quadcopter pitch-axis attitude control","PID DC-motor step response","ESC yaw-stability controller","Motor d-q current control (FOC)","Engine torque-map sweep","Battery SoC observer"],
  },
  "chemical-process": {
    intro: "Reactors, separations, and water treatment — process dynamics and control from kinetics to compliance.",
    highlights: [
      {
        slug: "113-reactor-scram-transient",
        title: "Reactor SCRAM transient",
        description: "Textbook point-reactor kinetics: a 1-dollar reactivity insertion drives the prompt drop and precursor-tail decay. Tweak the delayed-neutron fractions and watch the tail change.",
        image: img_113_reactor_scram_transient,
        imageAlt: "Screenshot from the “Reactor SCRAM transient” DjiniousLab demo",
      },
      {
        slug: "114-reactor-xenon-poisoning",
        title: "Xenon poisoning",
        description: "The iodine pit after shutdown — xenon-135 builds, poisons the core, and blocks immediate restart until it decays away.",
        image: img_114_reactor_xenon_poisoning,
        imageAlt: "Screenshot from the “Xenon poisoning” DjiniousLab demo",
      },
      {
        slug: "117-activated-sludge-load-step",
        title: "Activated sludge plant",
        description: "Biomass response in an activated-sludge basin to an influent COD load step — the workhorse of municipal wastewater treatment.",
        image: img_117_activated_sludge_load_step,
        imageAlt: "Screenshot from the “Activated sludge plant” DjiniousLab demo",
      },
      {
        slug: "120-aeration-do-pid-control",
        title: "Aeration DO control",
        description: "A PID holds dissolved oxygen at a 2 mg/L setpoint through a step in oxygen demand — closed-loop aeration control.",
        image: img_120_aeration_do_pid_control,
        imageAlt: "Screenshot from the “Aeration DO control” DjiniousLab demo",
      },
      {
        slug: "92-ph-neutralization",
        title: "pH neutralization",
        description: "A PI controller with non-linear gain scheduling on the notoriously stiff titration curve, revealing the 10× sensitivity step near pH 4.",
        image: img_92_ph_neutralization,
        imageAlt: "Screenshot from the “pH neutralization” DjiniousLab demo",
      },
      {
        slug: "65-cascade-reactor",
        title: "Cascade reactor-temp control",
        description: "Cascade reactor-temperature control — an inner jacket loop nested inside an outer reactor loop rejecting a feed disturbance.",
        image: img_65_cascade_reactor,
        imageAlt: "Screenshot from the “Cascade reactor-temp control” DjiniousLab demo",
      },
    ],
    rest: ["Chlorination CT compliance","Membrane fouling flux decline","Smith predictor dead-time control","Fed-batch yeast fermentation","HVAC building thermal control","Demand-controlled ventilation","Reservoir depletion forecast","Well IPR, declining pressure","Gas-oil separator throughput","Water-cut breakthrough"],
  },
  "geophysics-climate": {
    intro: "Earth systems — aquifers, climate feedbacks, ice sheets, and atmospheric chemistry.",
    highlights: [
      {
        slug: "145-theis-aquifer-pumping-test",
        title: "Theis aquifer pumping test",
        description: "Theis well drawdown over a 24-hour aquifer pumping test — the textbook hydrogeology transient.",
        image: img_145_theis_aquifer_pumping_test,
        imageAlt: "Screenshot from the “Theis aquifer pumping test” DjiniousLab demo",
      },
      {
        slug: "147-contaminant-plume-100-year-migration",
        title: "Contaminant plume migration",
        description: "100 years of advection-dispersion as a contaminant plume migrates through an aquifer.",
        image: img_147_contaminant_plume_100_year_migration,
        imageAlt: "Screenshot from the “Contaminant plume migration” DjiniousLab demo",
      },
      {
        slug: "169-greenland-mass-balance-warming",
        title: "Greenland mass balance",
        description: "Greenland surface mass balance — melt versus accumulation under a 0 → 4 °C warming ramp at the 2000 m band.",
        image: img_169_greenland_mass_balance_warming,
        imageAlt: "Screenshot from the “Greenland mass balance” DjiniousLab demo",
      },
      {
        slug: "80-ice-albedo-feedback",
        title: "Ice-albedo feedback",
        description: "Closed-loop ice-albedo feedback driving snowball-Earth bistability — a climate tipping point on the canvas.",
        image: img_80_ice_albedo_feedback,
        imageAlt: "Screenshot from the “Ice-albedo feedback” DjiniousLab demo",
      },
      {
        slug: "155-co2-atmospheric-growth-50yr",
        title: "CO2 atmospheric growth",
        description: "A 50-year CO2 projection under current emissions, from a 2-box atmosphere-ocean carbon model.",
        image: img_155_co2_atmospheric_growth_50yr,
        imageAlt: "Screenshot from the “CO2 atmospheric growth” DjiniousLab demo",
      },
      {
        slug: "62-climate-radiative",
        title: "Climate radiative balance",
        description: "A zero-dimensional radiative-balance model coupled to an ocean mixed layer — the simplest honest climate model.",
        image: img_62_climate_radiative,
        imageAlt: "Screenshot from the “Climate radiative balance” DjiniousLab demo",
      },
    ],
    rest: ["Storm recharge aquifer response","SCS curve-number runoff","Methane emission-cut scenario","2-box carbon cycle","Glen's ice flow law","Ice-sheet volume projection","Glacier calving → sea level","Diurnal ozone cycle","PM2.5 Gaussian plume"],
  },
  "materials-mechanics": {
    intro: "Materials and structural mechanics — phase transformations, fatigue, diffusion, and resonance.",
    highlights: [
      {
        slug: "128-paris-fatigue-pressure-vessel",
        title: "Paris-law fatigue",
        description: "Crack growth from a 0.1 mm inspection flaw to 5 mm failure under the Paris fatigue law — pressure-vessel life prediction.",
        image: img_128_paris_fatigue_pressure_vessel,
        imageAlt: "Screenshot from the “Paris-law fatigue” DjiniousLab demo",
      },
      {
        slug: "125-pearlite-jmak-isothermal",
        title: "Pearlite transformation",
        description: "Isothermal pearlite-transformation kinetics at 800 K via JMAK — the phase-fraction S-curve of a steel.",
        image: img_125_pearlite_jmak_isothermal,
        imageAlt: "Screenshot from the “Pearlite transformation” DjiniousLab demo",
      },
      {
        slug: "173-sdof-building-resonance",
        title: "SDOF building resonance",
        description: "A single-degree-of-freedom model of a 5-story RC building hitting resonance at its 2 Hz natural frequency.",
        image: img_173_sdof_building_resonance,
        imageAlt: "Screenshot from the “SDOF building resonance” DjiniousLab demo",
      },
      {
        slug: "126-arrhenius-diffusion-temperature-sweep",
        title: "Arrhenius diffusion",
        description: "The diffusion coefficient swept from 700 K to 1500 K — the Arrhenius temperature dependence of solid-state diffusion.",
        image: img_126_arrhenius_diffusion_temperature_sweep,
        imageAlt: "Screenshot from the “Arrhenius diffusion” DjiniousLab demo",
      },
      {
        slug: "88-mass-spring-resonance",
        title: "Forced mass-spring resonance",
        description: "A sinusoidally-driven second-order oscillator showing resonant amplification at ω_n and off-resonance suppression.",
        image: img_88_mass_spring_resonance,
        imageAlt: "Screenshot from the “Forced mass-spring resonance” DjiniousLab demo",
      },
      {
        slug: "28-mass-spring-damper",
        title: "Mass-spring-damper ringdown",
        description: "The acausal hello-world — mass, spring, and damper wired through the 1-D mechanical pin domain; the solver derives the ringdown from connectivity.",
        image: img_28_mass_spring_damper,
        imageAlt: "Screenshot from the “Mass-spring-damper ringdown” DjiniousLab demo",
      },
    ],
    rest: ["Stress-relaxation of a bolt","Bouncing ball (event detection)","Pendulum energy conservation","Seismic response spectrum","PGA attenuation (M=7)","Soft-soil amplification","Seismic event: Richter + SDOF"],
  },
  "signal-processing-telecom": {
    intro: "Signal processing and communications — modulation, carrier recovery, and adaptive filtering.",
    highlights: [
      {
        slug: "72-qpsk-constellation",
        title: "QPSK constellation",
        description: "A QPSK modulator mapping a bit stream onto the four constellation points — the workhorse of digital comms.",
        image: img_72_qpsk_constellation,
        imageAlt: "Screenshot from the “QPSK constellation” DjiniousLab demo",
      },
      {
        slug: "63-telecom-pll",
        title: "PLL carrier locking",
        description: "A phase-locked loop acquiring and tracking a carrier — phase error driving to zero as the loop locks.",
        image: img_63_telecom_pll,
        imageAlt: "Screenshot from the “PLL carrier locking” DjiniousLab demo",
      },
      {
        slug: "90-lms-equalizer",
        title: "LMS adaptive equalizer",
        description: "A 3-tap LMS adaptive filter learning the inverse of a scalar channel gain — adaptive equalization in action.",
        image: img_90_lms_equalizer,
        imageAlt: "Screenshot from the “LMS adaptive equalizer” DjiniousLab demo",
      },
      {
        slug: "84-agc-pll-chain",
        title: "AGC + PLL signal chain",
        description: "An automatic-gain-control front end feeding a PLL on a fading carrier — a small but complete receiver chain.",
        image: img_84_agc_pll_chain,
        imageAlt: "Screenshot from the “AGC + PLL signal chain” DjiniousLab demo",
      },
      {
        slug: "83-hampel-outlier",
        title: "Hampel outlier rejection",
        description: "A Hampel median filter knocking out impulsive outliers from a noisy signal while preserving the underlying trend.",
        image: img_83_hampel_outlier,
        imageAlt: "Screenshot from the “Hampel outlier rejection” DjiniousLab demo",
      },
      {
        slug: "86-allan-variance",
        title: "Allan-variance estimate",
        description: "A running Allan-variance estimate — the standard tool for characterizing oscillator and sensor noise.",
        image: img_86_allan_variance,
        imageAlt: "Screenshot from the “Allan-variance estimate” DjiniousLab demo",
      },
    ],
    rest: ["Audio dynamic-range compression","Audio clip distortion"],
  },
  "power-electronics-energy": {
    intro: "Power electronics and energy — converters, inverters, storage, and grid support.",
    highlights: [
      {
        slug: "34-buck-converter",
        title: "Averaged buck converter",
        description: "A 24 V → 12 V averaged buck on the canvas tracking a duty-cycle step on a Rodas5P stiff solve — the first-pass topology check every power-electronics textbook opens with.",
        image: img_34_buck_converter,
        imageAlt: "Screenshot from the “Averaged buck converter” DjiniousLab demo",
      },
      {
        slug: "104-grid-tie-pq-inverter",
        title: "Grid-tie PQ inverter",
        description: "Decoupled active/reactive current-command decomposition for a 5 kW residential PV inverter under stepped P and Q setpoints.",
        image: img_104_grid_tie_pq_inverter,
        imageAlt: "Screenshot from the “Grid-tie PQ inverter” DjiniousLab demo",
      },
      {
        slug: "190-pem-electrolyzer-hydrogen-production",
        title: "PEM hydrogen electrolyzer",
        description: "An hour of hydrogen production at 10 kW through a PEM electrolyzer stack — current, voltage, and production rate over the run.",
        image: img_190_pem_electrolyzer_hydrogen_production,
        imageAlt: "Screenshot from the “PEM hydrogen electrolyzer” DjiniousLab demo",
      },
      {
        slug: "189-lithium-ion-charge-discharge-cycle",
        title: "Li-ion charge / discharge",
        description: "A full lithium-ion charge then discharge cycle — terminal voltage and state-of-charge tracked across the cycle.",
        image: img_189_lithium_ion_charge_discharge_cycle,
        imageAlt: "Screenshot from the “Li-ion charge / discharge” DjiniousLab demo",
      },
      {
        slug: "82-freq-droop-governor",
        title: "Frequency droop governor",
        description: "A droop governor trading grid frequency for generator power output — the primary-frequency-response primitive of grid stability.",
        image: img_82_freq_droop_governor,
        imageAlt: "Screenshot from the “Frequency droop governor” DjiniousLab demo",
      },
      {
        slug: "94-power-factor-correction",
        title: "Power-factor correction",
        description: "Sizing a shunt-capacitor bank to lift a 500 kW industrial load from 0.60 → 0.95 power factor against a contractual target.",
        image: img_94_power_factor_correction,
        imageAlt: "Screenshot from the “Power-factor correction” DjiniousLab demo",
      },
    ],
    rest: ["Molten-salt thermal storage","Supercapacitor RC charging","MPPT solar tracking"],
  },
  "biomedical-epidemiology": {
    intro: "Physiology and epidemiology — cardiovascular dynamics, pharmacokinetics, neurons, and outbreak curves.",
    highlights: [
      {
        slug: "137-sir-epidemic-curve",
        title: "SIR epidemic curve",
        description: "A COVID-style SIR outbreak in a 10,000-person community at R₀ = 3 — the susceptible/infected/recovered curves on one canvas.",
        image: img_137_sir_epidemic_curve,
        imageAlt: "Screenshot from the “SIR epidemic curve” DjiniousLab demo",
      },
      {
        slug: "138-seir-incubation-delay",
        title: "SEIR with incubation",
        description: "An SEIR model where the exposed compartment delays the visible outbreak — incubation reshaping the epidemic curve.",
        image: img_138_seir_incubation_delay,
        imageAlt: "Screenshot from the “SEIR with incubation” DjiniousLab demo",
      },
      {
        slug: "68-glucose-insulin",
        title: "Glucose-insulin dynamics",
        description: "The Bergman minimal model under a meal challenge — glucose and insulin trajectories of the body's regulation loop.",
        image: img_68_glucose_insulin,
        imageAlt: "Screenshot from the “Glucose-insulin dynamics” DjiniousLab demo",
      },
      {
        slug: "141-windkessel-arterial-pressure",
        title: "Arterial Windkessel",
        description: "Arterial pressure from a Windkessel model — pulsatile cardiac output versus the steady-flow approximation.",
        image: img_141_windkessel_arterial_pressure,
        imageAlt: "Screenshot from the “Arterial Windkessel” DjiniousLab demo",
      },
      {
        slug: "129-iv-bolus-plasma-decay",
        title: "IV bolus pharmacokinetics",
        description: "Single-compartment plasma decay after an IV bolus — the exponential washout at the heart of dosing.",
        image: img_129_iv_bolus_plasma_decay,
        imageAlt: "Screenshot from the “IV bolus pharmacokinetics” DjiniousLab demo",
      },
      {
        slug: "32-ecg-rpeak-detection",
        title: "ECG R-peak detection",
        description: "A biomedical canvas: raw ECG in, an R-peak detector block, beat markers out — real domain blocks, not toys.",
        image: img_32_ecg_rpeak_detection,
        imageAlt: "Screenshot from the “ECG R-peak detection” DjiniousLab demo",
      },
    ],
    rest: ["Vaccination → herd immunity","Quarantine intervention","Frank-Starling preload","Exercise cardiac output","Baroreceptor reflex","PPG heart-rate estimator","IV infusion to steady state","Oral Bateman absorption","PK/PD Hill coupling","EEG alpha bandpower","LIF neuron subthreshold","Izhikevich spiking neuron"],
  },
  "aerospace-marine": {
    intro: "Aerospace, astrodynamics, and marine — orbital mechanics, vessel dynamics, and ocean mixing.",
    highlights: [
      {
        slug: "57-kepler-hohmann",
        title: "Kepler orbit + Hohmann transfer",
        description: "Kepler orbit propagation plus a Hohmann transfer Δv calculation, from the astrodynamics library blocks — the trajectory in physical units.",
        image: img_57_kepler_hohmann,
        imageAlt: "Screenshot from the “Kepler orbit + Hohmann transfer” DjiniousLab demo",
      },
      {
        slug: "66-marine-nomoto",
        title: "Marine vessel Nomoto yaw",
        description: "A vessel's Nomoto yaw dynamics through a turning simulation — the first-order steering model of ship maneuvering.",
        image: img_66_marine_nomoto,
        imageAlt: "Screenshot from the “Marine vessel Nomoto yaw” DjiniousLab demo",
      },
      {
        slug: "87-salinity-mixing",
        title: "Two-layer ocean salinity mixing",
        description: "Two-layer ocean salinity mixing — the stratified-exchange model behind estuary and deep-water dynamics.",
        image: img_87_salinity_mixing,
        imageAlt: "Screenshot from the “Two-layer ocean salinity mixing” DjiniousLab demo",
      },
    ],
    rest: ["Gravitational-wave chirp","Roche-lobe geometry","Hubble redshift → distance","Stellar mass-luminosity"],
  },
  "optics-photonics": {
    intro: "Optics and photonics — interference, polarization, and photon statistics.",
    highlights: [
      {
        slug: "185-mach-zehnder-fringe-pattern",
        title: "Mach-Zehnder fringes",
        description: "A Mach-Zehnder interferometer's fringe pattern as the phase sweeps 0 → 4π — the canonical two-path interference demo.",
        image: img_185_mach_zehnder_fringe_pattern,
        imageAlt: "Screenshot from the “Mach-Zehnder fringes” DjiniousLab demo",
      },
      {
        slug: "186-malus-law-polarizer-sweep",
        title: "Malus's law",
        description: "Transmitted intensity through a polarizer swept 0 → π/2 — Malus's cos²θ law traced out.",
        image: img_186_malus_law_polarizer_sweep,
        imageAlt: "Screenshot from the “Malus's law” DjiniousLab demo",
      },
      {
        slug: "97-laser-rate-equations",
        title: "Laser rate equations",
        description: "Sub-threshold carrier and photon dynamics of a semiconductor laser — the rate equations that govern lasing onset.",
        image: img_97_laser_rate_equations,
        imageAlt: "Screenshot from the “Laser rate equations” DjiniousLab demo",
      },
    ],
    rest: ["Beer-Lambert + Fabry-Perot","Beam-splitter power split","Single-photon counting"],
  },
  "economics-queueing": {
    intro: "Operations and finance — queueing, inventory, forecasting, and option pricing.",
    highlights: [
      {
        slug: "181-mm1-queue-utilization-hockey-stick",
        title: "M/M/1 queue",
        description: "Server utilisation versus waiting time for an M/M/1 queue — the hockey-stick that explains why busy systems fall over.",
        image: img_181_mm1_queue_utilization_hockey_stick,
        imageAlt: "Screenshot from the “M/M/1 queue” DjiniousLab demo",
      },
      {
        slug: "101-black-scholes-delta",
        title: "Black-Scholes delta",
        description: "The option delta Φ(d₁) traced across a moneyness sweep — the hedge ratio at the heart of Black-Scholes.",
        image: img_101_black_scholes_delta,
        imageAlt: "Screenshot from the “Black-Scholes delta” DjiniousLab demo",
      },
      {
        slug: "76-bollinger-bands",
        title: "Bollinger bands",
        description: "A Bollinger-band price envelope on the canvas — a rolling mean with ±2σ bands tracking a price series.",
        image: img_76_bollinger_bands,
        imageAlt: "Screenshot from the “Bollinger bands” DjiniousLab demo",
      },
      {
        slug: "100-holt-demand-forecast",
        title: "Holt demand forecast",
        description: "Holt double-EMA forecasting tracking level and trend on a noisy synthetic demand series.",
        image: img_100_holt_demand_forecast,
        imageAlt: "Screenshot from the “Holt demand forecast” DjiniousLab demo",
      },
      {
        slug: "182-eoq-inventory-sqrt-demand-sweep",
        title: "Wilson EOQ inventory",
        description: "The Wilson economic-order-quantity model with annual demand swept — the √D growth of the optimal order size.",
        image: img_182_eoq_inventory_sqrt_demand_sweep,
        imageAlt: "Screenshot from the “Wilson EOQ inventory” DjiniousLab demo",
      },
      {
        slug: "184-bullwhip-variance-amplification-quadratic",
        title: "Bullwhip effect",
        description: "Order-variance amplifying quadratically up a supply chain — the bullwhip effect made visible.",
        image: img_184_bullwhip_variance_amplification_quadratic,
        imageAlt: "Screenshot from the “Bullwhip effect” DjiniousLab demo",
      },
    ],
    rest: ["Safety stock vs lead time","Inventory PID + bullwhip","GARCH(1,1) volatility","Bottleneck queue (peak hour)"],
  },
  "parametric-3d-cad": {
    intro: "Parametric 3-D / CAD with the3djin — programmatic geometry, parameter sweeps, and STEP export.",
    highlights: [
    ],
    rest: ["Parametric mug — revolve + handle","Sweep variants","STEP export from ParameterSet","Torus-handle sweep"],
  },
};
